import React from 'react';
import { Controller, FieldValues, UseControllerProps } from 'react-hook-form';

import CkRichContentEditor from './rich-text-editor';

interface ControlledCKEditorProps<TFieldValues extends FieldValues>
  extends UseControllerProps<TFieldValues> {
  disabled?: boolean;
  isVisible?: boolean;
  label?: string;
  placeholder?: string;
  testId?: string;
}

export function ControlledCKEditor<TFieldValues extends FieldValues>({
  name,
  control,
  rules,
  disabled,
  isVisible = true,
  label,
  placeholder,
  testId,
}: ControlledCKEditorProps<TFieldValues>): React.JSX.Element | null {
  if (!isVisible) return null;

  return (
    <Controller<TFieldValues>
      control={control}
      rules={rules}
      name={name}
      render={({
        field: { onChange, value, onBlur },
        fieldState: { error },
      }) => (
        <CkRichContentEditor
          value={value ?? ''}
          onChange={onChange}
          onBlur={onBlur}
          disabled={disabled}
          label={label}
          placeholder={placeholder}
          testId={testId ?? name}
          required={Boolean(rules?.required)}
          errorMessage={error?.message}
        />
      )}
    />
  );
}
